import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';
import { AuthTenant } from '@src/api/tenant/auth/tenantAuthStatusApiClient';

type TenantUser = {
  family_name: string;
  first_name: string;
  family_name_kana: string;
  first_name_kana: string;
  email: string;
  new_password?: string;
  new_password_confirmation?: string;
  avatar_url: string;
  display_name: string;
  affiliation: string;
  position: string;
  introduction: string;
  two_factor_enabled: boolean;
  email_notification_enabled: boolean;
};
type ProfileShowResponse = {
  user: TenantUser & {
    logged_in_at: string | null;
  };
  tenant: AuthTenant;
};
type ProfileUpdateRequest = {
  tenant_user: Omit<TenantUser, 'email'>;
};
type ProfilePreValidateRequest = {
  tenant_user: TenantUser;
};
type ProfileUpdateResponse = unknown;
export type ProfileUpdateErrorResponse = {
  tenant_user: {
    family_name: string[];
    first_name: string[];
    family_name_kana: string[];
    first_name_kana: string[];
    email?: string[];
    new_password?: string[];
    new_password_confirmation?: string[];
    avatar_url: string[];
    display_name: string[];
    affiliation: string[];
    position: string[];
    introduction: string[];
    two_factor_enabled: string[];
    email_notification_enabled: string[];
  };
};
type UploadAvatarResponse = {
  url: string;
};
type UploadAvatarErrorResponse = {
  file: string[];
};
type VerifyEmailRequest = {
  code: string;
  password: string;
};
type VerifyEmailResponse = unknown;
export type VerifyEmailErrorResponse = {
  code: string[];
  password: string[];
  messages: string[];
};

export const tenantProfileApiClient = {
  show: async (): Promise<ApiResult<ProfileShowResponse>> => {
    return await axiosClient.get('/tenant/profile');
  },
  update: async (
    params: ProfileUpdateRequest,
  ): Promise<ApiResult<ProfileUpdateResponse, ProfileUpdateErrorResponse>> => {
    return await axiosClient.put('/tenant/profile', params);
  },
  uploadAvatar: async (
    file: File,
  ): Promise<ApiResult<UploadAvatarResponse, UploadAvatarErrorResponse>> => {
    const form = new FormData();
    form.append('file', file);
    return await axiosClient.post('/tenant/profile/avatar', form, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  preValidate: async (
    params: ProfilePreValidateRequest,
  ): Promise<ApiResult<ProfileUpdateResponse, ProfileUpdateErrorResponse>> => {
    return await axiosClient.post('/tenant/profile/pre-validate', params);
  },
  verifyEmail: async (
    params: VerifyEmailRequest,
  ): Promise<ApiResult<VerifyEmailResponse, VerifyEmailErrorResponse>> => {
    return await axiosClient.post('/tenant/profile/email/verify', params);
  },
};
